/** @format */

import { Component, computed, ChangeDetectionStrategy } from '@angular/core';
import { HmfStarRatingsComponent } from '@dsg-tech/homefield-angular';
import { StandardFilterComponent } from '../standard-filter/standard-filter.component';
import { FilterOptionComponent } from '../filter-option/filter-option.component';

@Component({
  selector: 'plp-components-rating-filter',
  imports: [HmfStarRatingsComponent, FilterOptionComponent],
  templateUrl: './rating-filter.component.html',
  styleUrl: './rating-filter.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RatingFilterComponent extends StandardFilterComponent {
  readonly processedFilterOptions = computed(() =>
    this.filterOptions()
      .map((option) => {
        const numericValue = Number.parseInt(option.value.replace('+', ''), 10);
        return {
          option,
          numericValue,
          extraText: numericValue < 5 ? '& Up' : '',
        };
      })
      .filter((option) => option.numericValue >= 3),
  );
}
